<template>
    <div>
        <div class="baseContent">

            <div class="prev">
                <img src="../assets/larrow.png" @click="arrowClick('prev')" />
            </div>
            <el-carousel :autoplay="false" arrow="never" indicator-position="none" ref="cardShow" type="card">
                <el-carousel-item class="centerBg">
                    <img src="../assets/bgAutoplay.png" alt="">
                    <div class="loremBox">
                        <div class="loremlpsum">
                            Low Barriers to Enter
                        </div>
                        <div class="inproution">
                            <div>Players can easily access the game without the need to purchase any equipment or download and install any software. As a hyper-casual game, Hero Card is very suitable for both players who are new to blockchain games and crypto natives, with simple and fun gameplay.</div>
                        </div>
                    </div>
                </el-carousel-item>
                <el-carousel-item class="centerBg">
                    <img src="../assets/bgAutoplay.png" alt="">
                    <div class="loremBox">
                        <div class="loremlpsum">
                            Fast and Secure Transaction Process
                        </div>
                        <div class="inproution">
                            <div>With years of experience in blockchain game development, X World Games ensures the Hero Card transaction process is the fastest, most convenient and secure to date in our shipped products.</div>
                        </div>
                    </div>
                </el-carousel-item>
                <el-carousel-item class="centerBg">
                    <img src="../assets/bgAutoplay.png" alt="">
                    <div class="loremBox">
                        <div class="loremlpsum">
                            Unique Reward Model
                        </div>
                        <div class="inproution">
                            <div>The winner is rewarded with one Lottery which can be used to exchange for Limited Cards. Other players, though defeated, can still get certain amount of Bill which shares the match participants’ entry fees. Both parties can enjoy this fabulous game while reaping the possible high return on investment.</div>
                        </div>
                    </div>
                </el-carousel-item>
                <el-carousel-item class="centerBg">
                    <img src="../assets/bgAutoplay.png" alt="">
                    <div class="loremBox">
                        <div class="loremlpsum">
                            High Aesthetic and Collection Value
                        </div>
                        <div class="inproution">
                            <div>Every hero card is designed by well-known artists, each with unique ACG styles. Verifiable scarcity and ownership on-chain makes heros cards highly collectible on the market.</div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
            <div class="next">
                <img src="../assets/rarrow.png" @click="arrowClick('next')" />
            </div>
        </div>
    </div>
</template>
<script>
// import Swiper from "swiper";
// import "swiper/css/swiper.css";
export default {
    data() {
        return {
            heigh: "300px",
        };
    },
    mounted() {
        //     // 获取窗口的宽度
        //     var winWidth = document.documentElement.clientWidth;
        //    window.onresize = function() {
        //         // 获取窗口的宽度
        //         var winWidth = document.documentElement.clientWidth;
        //       console.log(winWidth);
        //         if (winWidth < 768) {
        //             this.heigh="100px";
        //             console.log(this.heigh);
        //         } else {
        //             console.log(this.heigh);
        //         }
        //     };
    },
    methods: {
        arrowClick(val) {
            if (val === "next") {
                this.$refs.cardShow.next();
            } else {
                this.$refs.cardShow.prev();
            }
        },
    },
};
</script>
<style scoped>
/* .swiper-container {
    width: 100%;
    height: 100%;
}

.swiper-slide {
    font-size: 18px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 387.27px;
    transition: 300ms;
    transform: scale(0.5);
    background-color: #6f307c;
    position: relative;
}

.bigfeam {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}

.swiper-slide-active,
.swiper-slide-duplicate-active {
    transform: scale(1.6);
} */
@font-face{
	font-family:'Raleway';
	src: url('../assets/Raleway-Regular.ttf');
}
.baseContent {
    position: relative;
}
.next {
    position: absolute;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 999;
}
.next img {
    width: 57px;
    /* height: 57px; */
}
.prev {
    position: absolute;
    left: -20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 999;
}

.prev img {
    width: 57px;
    /* height: 57px; */
}
.loremBox {
    width: 100%;
    height: 100%;
    /* margin-top: 60px; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}

.loremlpsum {
    color: #fdfdfd;
    /* font-family: Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif; */
    /* -webkit-text-fill-color: transparent; */
	font-family:'Raleway';
    padding-top: 56px;
    font-size: 24px;
    z-index: 333;
}
.inproution {
    width: 70%;
    height: 45%;
    margin-top: 40px;
    color: #fdfdfd;
	font-family:'Raleway';
    font-size: 18px;
	line-height:21px;
    overflow-y: scroll;
    z-index: 333;
    scroll-behavior: smooth;
}
.inproution h3{
	font-weight: normal;
}
.inproution::-webkit-scrollbar {
    width: 5px;
	display: none;
}
.inproution::-webkit-scrollbar-track {
    background: linear-gradient(0deg, #6f307c 0%, #6f307c 100%);
    border-radius: 10px;
}
.inproution::-webkit-scrollbar-thumb {
    background: transparent;
    /* box-shadow: 0px 0px 0px 100vh black; */
    border-radius: 5px;
}
.inproution:-webkit-scrollbar-button {
    background-color: #1275e5;
}
.inproution div {
    line-height: 20px;
}
.el-carousel--horizontal{
	overflow-x: initial;
}
.el-carousel__item--card{
	width: 50% !important;
}
.el-carousel__item:nth-child(2n) {
    background-color: #6f307c;
}
.el-carousel__item.is-active{
	border-left: 8px solid rgb(155,117,165);
	border-right: 8px solid rgb(155,117,165);
}
.el-carousel__item:nth-child(2n + 1) {
    background-color: #6f307c;
}
</style>
<style>
.centerBg {
    border-radius: 30px;
    width: 745px;
    height: 337.2px;
}

.centerBg img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    /* vertical-align: middle; */
    /* background: url("../assets/smallFram.png") center/cover;
    background-size: 100% 100%; */
}
.el-carousel__container {
    height: 21.2rem !important;
	overflow: hidden;
}
.el-carousel__item {
    height: 337.2px !important;
}
@media screen and (max-width: 980px) {
    /* .briefText{
        font-size: 12px;
    } */
    .inproution{
        font-size: 12px;


    } 
}
</style>